import React, { useState, useEffect } from 'react';
import styles from "./Participants.module.scss"
import ConversationBubble from '../ConversationBubble';
import BackgroundImg from '../assets/wood-pattern.png'


export const Participant = ({data, details=true}) => {

    return (
        <div className={styles.participant}>
            <figure>
                <img src={data.img} />
            </figure>

            {details && <div className={styles.details}>
                <span className={styles.name}>{data.name}</span>
                <span className={styles.role}>{data.role}</span>
                {data.team && <span className={styles.team}>{data.team}</span>}
            </div>
            }
            
        </div>
    )
}

export const ParticipantSpeech = ({participant, message, position, className, onContinue}) =>{

    const [currentMessage, setCurrentMessage] = useState(message)


    /**
     * if a new message arrives
     */
    useEffect(() => {
        setCurrentMessage(message)
    }, [message])

    return (<div  className={`${styles.holder} ${className}`} key={participant.id}>
        {currentMessage && 
            <ConversationBubble text={currentMessage.message} button={currentMessage.button ?? 'Next'} onContinue={onContinue} position={position} />
        }
        <Participant data={participant} />
    </div>)
}


const Participants =  ({participants, conversation, startConversation, endConversation}) => {

    const [messageIndex, setMessageIndex] = useState(0)

    /**
     * if a new conversation arrives
     * will handle the first message
     */
    useEffect(() => {
        setMessageIndex(0)
    }, [conversation])

    /**
     * get the message of the participant
     * @param {*} message 
     * @param {*} participant 
     * @returns 
     */
    const getParticipantMessage = (participant) => {  
        const message = conversation[messageIndex]
        return startConversation && message.participant === participant.id ? message : false
    } 

    /**
     * how
     * @param {*} currentIndex 
     * @returns 
     */
    const messageLeft = (currentIndex) =>{
        const messages = conversation.filter((conversation, index) => currentIndex < index)
        return messages.length
    }

    /**
     * Handle Next Message
     */
    const handleContinue = () =>{

        const message = conversation[messageIndex]
        console.log(message.action)
        if(message.action){
            setMessageIndex(0)
            endConversation()
            conversation[messageIndex].action()
        }
        else if(messageLeft(messageIndex) > 0){
            const nextMessage = messageIndex + 1
            setMessageIndex(nextMessage)
        }
        else{
            setMessageIndex(0)
            endConversation()
        }

        if(message.markAsRead) {
            message.markAsRead()
        }


    }

    const backgroundStyle = {backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.4458158263305322) 0%, rgba(0,0,0,0.76234243697479) 100%), url(" + BackgroundImg + ")"}

    return (
        <div className={styles.participants} style={backgroundStyle}>
            { 
                participants.map((participant) => {
                    
                    const message = getParticipantMessage(participant)

                    return ( 
                    <ParticipantSpeech 
                        key={participant.id}
                        position="top"
                        className={styles.holder}
                        message={message}
                        participant={participant}
                        onContinue={handleContinue} />
                    )
                })
            }
        </div>

    )


}

export default Participants;